export default __webpack_public_path__ + "static/ccl-3-e81447fe07dbd44250501ef88c6df5cd.png";